import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">Contacts</h1>
      <p>If you have any questions relating to the MyScan service or would like to check if you can use Preston MyScan for your claim, please contact Preston City Council.</p>
      <p>You can contact Preston City Council on:</p>
      <p><strong>01772 906900</strong></p>
      <p><strong>Normal Opening Hours</strong></p>
      <p>Monday: Friday 9am - 5pm<br />Thursdays: 10am - 5pm</p>

    </React.Fragment>
  );
}
